<template>
  <video
    v-if="src"
    class="player"
    controls
    :src="src"
    :autoplay="autoplay"
  ></video>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "VideoPlayer",

  data() {
    return {};
  },
  props: {
    src: VueTypes.string,
    autoplay: VueTypes.bool.def(false),
  },
});
</script>
<style scoped>
.player {
  width: 100%;
}
</style>
